import { useQuery } from '@tanstack/react-query'; //-tech-debt-react-query;
import { fetchItems } from '../support/queries';

/**
 * Every opportunity the person is on, each carrying the SE tasks they own on it (`se_activities`), from
 * `sf/team-opportunities-se-activities/`. Always requested unfiltered: callers window by `ActivityDate`
 * themselves, so switching a period is instant and doesn't depend on the server parsing range filters.
 */
export function useSfTeamOppActivities(email: string | null | undefined, options: { enabled?: boolean } = {}) {
  const normalizedEmail = String(email || '').toLowerCase() || null;
  return useQuery<any>({
    queryKey: ['SfTeamOppSeActivities', normalizedEmail],
    queryFn: () =>
      fetchItems(
        'sf/team-opportunities-se-activities/',
        { email: normalizedEmail, current_time_filter: 'all' },
        { includePageSize: false },
      ),
    enabled: !!normalizedEmail && (options.enabled ?? true),
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  });
}
